module.exports = __webpack_public_path__ + "img/LoGoAMB.1260db39.png";